import barba from '@barba/core';
import {
    defaultAnimationOnce,
    defaultAnimationEnter,
    defaultAnimationLeave,
    animationLeaveToContact,
    animationEnterToContact,
} from "./animations/default"
import {init_home_carousel, destroy_home_carousel} from "./homeCarousel"
let timer = null;
const init = () => {
    console.log("Initialisation de barba");
    barba.init({
        // Disable BarbaJS on click on the WP admin-bar item
        prevent: ({el}) => (el.classList && el.classList.contains('ab-item')),
        preventRunning: true,
        debug: false,
        transitions: [
            {
              name: 'contact',
              to:{
                  namespace:['page-contact']
              },
                once(data) {
                    defaultAnimationOnce(data.next.container);
                },
                leave: (data) => animationLeaveToContact(data.current.container),
                enter(data) {
                    animationEnterToContact(data.next.container);
                }
            },
            {
                name: 'opacity-transition',
                sync: false,
                once(data) {
                    defaultAnimationOnce(data.next.container);
                },
                leave: (data) => defaultAnimationLeave(data.current.container),
                enter(data) {
                    defaultAnimationEnter(data.next.container);
                }
            },
        ],
        // run custom code
        views: [{
            namespace: 'front-page',
            afterEnter: (e) => {
                // refresh the parallax based on new page content
                console.log("after enter");
                if(e.current.container){
                    clearTimeout(timer);
                    timer = setTimeout(init_home_carousel, 1000);
                }else{
                    clearTimeout(timer);
                    timer = setTimeout(init_home_carousel, 4000);
                }
                // init_home_carousel()
            },
            afterLeave: () => {
                destroy_home_carousel()
            }
        }]
    })
}
export {init};
